import { Link } from "react-router-dom";
import { api } from "../../../api/config";
import lng from "../../../utils/language";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import style from "./Reservation.module.css";
import Grid from "../../../layout/grid/Grid";
import { Box, Typography } from "@mui/material";
import Loader from "../../../components/general/loader/Loader";
import ConstructionIcon from '@mui/icons-material/Construction';
import TextWrapper from "../../../components/general/text/TextWrapper";

export default function ReservationActivities() {
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);
    const [reservation, setReservation] = useState([]);
    const [message, setMessage] = useState('');
    const { language } = useSelector((state) => state.language);

    useEffect(() => {
        api.get("reservation/activities")
            .then((res) => {
                if (res?.data?.success) {
                    setReservation(res?.data?.activities);
                }
                else {
                    setError(true);
                    setMessage(res?.data?.message);
                }
            })
            .catch((error) => {
                // console.error('test');
            })
            .finally(() => {
                setLoading(false);
            })
    }, []);

    return (
        <>
            {!loading ? (
                <Box className={`container ${style.atractions}`}>
                    {
                        error ?
                        <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', border: 'solid 1px #FFF', padding: '20px', borderRadius: '10px', width: 'max-content', marginX: 'auto'}}>
                            <ConstructionIcon sx={{marginRight: '10px'}} fontSize="large" />
                            <Typography variant="h5" textAlign={'center'}>{message[language]}</Typography>
                        </Box>
                            :
                            reservation.length ?
                                <>
                                    <TextWrapper title={lng[language]["bookNow"]} desc="" />
                                    <Grid no={"Activities"}>
                                        {
                                            reservation?.map(data => (
                                                <Link style={{ backgroundImage: `url(https://hyper-active.com/assets/reservation/${data.img})` }} to={`/${data.route}`} className={`${style.atractionsLink}`} key={data.externalId} state={{ name: data.nameAlb, id: data.externalId }}>
                                                    {data.OnlyLogo === 0 && data.nameAlb}
                                                </Link>
                                            ))
                                        }
                                    </Grid>
                                </>
                                :
                                <Box paddingTop={{ md: 10, xs: 5 }}>
                                    <Typography variant="h5" fontWeight={'bold'} textAlign={'center'} fontSize={{ md: '30px', xs: '20px' }}>{message[language]}</Typography>
                                </Box>           
                    }
                </Box>
            ) : (
                <Loader />
            )}
        </>
    );
}